'use client';

import React from "react";
import "../assets/styles/Publication.scss";

const publications = [
  {
    label: "RF",
    title: "An Extension of Random Forest-Clustering Schemes Which Works with Partition-Level Constraints",
    authors: "M. Bicego, H.A. Hassan",
    venue: "International Conference on Pattern Recognition pp 93–108, Dec 2024",
    link: "https://dl.acm.org/doi/10.1007/978-3-031-78383-8_7",
  },
  {
  label: "DL",
  title: "Skin Lesion Classification Using Deep Learning Techniques",
  authors: "Hafiz Ahmad Hassan, Bismillah Jan, Adeel Khan, Zahra Ahmad, Fatima Tahira",
  venue: "International Conference of Green and Human Information Technology Proceedings, pp. 318-320, January 2019, South Korea.",
  link: "https://drive.google.com/file/d/1DGmK1sOdxQXOE00z2XT8BY8LG41TSK9g/view"
  },

  {
    label: "RFC",
    title: "Semi-supervised Random Forest Clustering",
    authors: "Hafiz Ahmad Hassan",
    venue: "Master's Thesis: University of Verona",
    link: "https://www.overleaf.com/project/65204b447d07afbfda143e0f",
  },
  {
    label: "DL",
    title: "Skin Lesion Detection and Classification",
    authors: "Hafiz Ahmad Hassan, Adeel Khan, Zahra Ahmad, Fatima Tahira",
    venue: "Bachelor's thesis: FAST National University of Computer and Emerging Sciences, Lahore, Pakistan",
    link: "https://www.scribd.com/document/430950469/Skin-Lesion-Detection-and-Classification",
  },
  {
  label: "SAI",
  title: "Transition Aware Activity Recognition Along Intracranial Pressure Prediction",
  authors: "Hafiz Ahmad Hassan*, Matthew Bancroft*, Ahmed Toma, Evangelos Mazemenos",
  venue: "Paper under review · University College London",
  link: ""
}


];

export default function Publication() {
  return (
    <div className="publications-container" id="publications">
      <h1>Academic Publications</h1>
      <div className="publications-grid">
        {publications.map((pub, index) => (
          <div className="publication" key={index}>
            <div className="zoom publication-thumbnail">
              <span className="thumbnail-label">{pub.label}</span>
            </div>
            <div className="publication-text">
              <a href={pub.link} target="_blank" rel="noreferrer">
                <h2>{pub.title}</h2>
              </a>
              <p>{pub.venue}</p>
              <p className="authors">{pub.authors}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}